<template>
  <CollaboratorFormModal
    ref="formModal"
    :scope="scope"
    :available-roles="availableRoles"
    :limits-usage="limitsUsage"
    :can-bypass-limits="canBypassLimits"
    entry-type="email"
    header-icon="cipUsersPlus"
    :show-personal-message="true"
    modal-class="modal-i-user"
    :entry-placeholder="$gettext('name@example.com (press Enter to add)')"
    @submit="handleSubmit"
  >
    <template #title>
      <translate translate-context="collaborators.invite">Invite collaborators</translate>
    </template>

    <template #description>
      <div class="font-weight-medium mb-1">
        <translate translate-context="collaborators.invite">Send invitation by email</translate>
      </div>
      <p>
        <translate translate-context="collaborators.invite">Invited users will receive an email with instructions to accept the invitation and access the platform.</translate>
      </p>
    </template>

    <template #entry-label>
      <translate translate-context="collaborators.invite">Email addresses</translate>
    </template>

    <template #entry-count-label>
      <translate translate-context="collaborators.invite">email(s)</translate>
    </template>

    <template #submit-text>
      <translate translate-context="collaborators.invite">Send Invitations</translate>
    </template>

    <template #no-roles-text>
      <translate translate-context="collaborators.invite">No roles available for invitation in this event.</translate>
    </template>
  </CollaboratorFormModal>
</template>

<script>
import {mapActions} from 'vuex'
import CollaboratorFormModal from './CollaboratorFormModal.vue'

export default {
  name: 'InviteCollaboratorModal',

  components: {
    CollaboratorFormModal
  },

  props: {
    scope: {
      type: Object,
      required: true
    },
    availableRoles: {
      type: Array,
      default: () => []
    },
    limitsUsage: {
      type: Object,
      default: null
    },
    canBypassLimits: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    ...mapActions('collaborators', [
      'inviteCollaborators',
      'fetchCollaborators'
    ]),

    open() {
      this.$refs.formModal.open()
    },

    close() {
      this.$refs.formModal.close()
    },

    async handleSubmit({entries, roleIds, personalMessage}) {
      try {
        const result = await this.inviteCollaborators({
          users: entries,
          roles: roleIds,
          personalMessage
        })

        if (result.success && result.success.length > 0) {
          const successMsg = this.$pgettext('collaborators.notification', '{count} invitations sent successfully')
          await this.notifySuccess(successMsg.replace('{count}', result.success.length))
        }

        if (result.errors && Object.keys(result.errors).length > 0) {
          const errorMessages = Object.entries(result.errors)
            .map(([email, error]) => {
              if (typeof error === 'object' && error.code) {
                return `${email}: ${this.$refs.formModal.translateLimitError(error.code, error.detail)}`
              }
              return `${email}: ${this.$refs.formModal.translateLimitError(error)}`
            })
            .join('\n')
          await this.notifyError(
            this.$pgettext('collaborators.notification', 'Some operations failed:\n') + errorMessages
          )
        }

        this.close()
        await this.fetchCollaborators()
        this.$emit('invited')
      } catch (error) {
        const errorCode = error.data?.code
        const errorMessage = this.$refs.formModal.translateLimitError(errorCode, error.data?.detail)
        await this.notifyError(errorMessage)
      }
    }
  }
}
</script>
